// extracted by mini-css-extract-plugin
export default {"table_wrapper":"ListKontrak_table_wrapper__h5A77"};